module.exports = __webpack_public_path__ + "assets/img/Blackpurl-Landing-Page-w720.9d6585d5.jpg";